import { render, staticRenderFns } from "./PsoriasisSpecificDataPhase.vue?vue&type=template&id=aef25c04&scoped=true&"
import script from "./PsoriasisSpecificDataPhase.vue?vue&type=script&lang=js&"
export * from "./PsoriasisSpecificDataPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef25c04",
  null
  
)

export default component.exports